import { render, staticRenderFns } from "./CanvasWorkOverviewPage.vue?vue&type=template&id=449b6a90"
import script from "./CanvasWorkOverviewPage.vue?vue&type=script&lang=js"
export * from "./CanvasWorkOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports